import { useHistory, useLocation } from 'react-router-dom';
import { paths } from 'routes';
import { BenchmarkTypes } from 'types/Benchmark';
import { Api } from '../api';

const getBody = (pathNameModule: string, values: any) => {
  const modules: any = {};
  function getCompositeWeighted(values: any) {
    return {
      name: `${values.name}`,
      typeId: 5,
      calculationFrequencyId: 2,
      baseCurrencyCode: 'USD',
      weightingMethodologyId: 3,
      includeBookedValues: false,
      timeWindows: [
        {
          fromDate: '2020-03-31T00:00:00',
          assetSelectionSetId: 1,
          tagRefPropertyDefinitionId: 1005,
          lineItems: [
            {
              returnComponentResourceId: 551,
              weightingComponentTagId: 6,
            },
          ],
        },
      ],
    };

    // return ({
    //   name: values.name,
    //   typeId: values.typeId,
    //   calculationFrequencyId: values.calculationFrequency,
    //   baseCurrencyCode: values.baseCurrency,
    //   weightingMethodologyId: values.weightingMethodology,
    //   includeBookedValues: values.isIncludeBookedValues ? true :false,
    //   timeWindows: [
    //     {
    //       fromDate: values.fromDate.toISOString(),
    //       assetSelectionSetId: values.assetSelectionSets,
    //       tagRefPropertyDefinitionId: values.property,
    //       lineItems: [
    //         {
    //           returnComponentResourceId: 551,
    //           weightingComponentTagId: 6
    //         }
    //       ]
    //     }
    //   ]
    // })
  }

  function getPullForward({
    name,
    baseCurrency,
    calculationFrequency,
    isIncludeBookedValues,
  }: any) {
    const timeWindows: any[] = [];
    values.timeWindows?.forEach((window: any) => {
      const timeWindow: any = {
        fromDate: window.fromDate.toISOString(),
        pullForwardLength: window.numberPeriods,
      };
      if (window.returnComponent.includes('-')) {
        timeWindow.returnComponentBenchmarkId = window.returnComponent;
      } else {
        timeWindow.returnComponentResourceId = Number(window.returnComponent);
      }
      timeWindows.push(timeWindow);
    });

    return {
      name: name,
      typeId: BenchmarkTypes.PullForward,
      calculationFrequencyId: calculationFrequency,
      baseCurrencyCode: baseCurrency,
      includeBookedValues: isIncludeBookedValues || false,
      timeWindows,
    };
  }

  const getAbsoluteReturn = ({
    name,
    baseCurrency,
    calculationFrequency,
    fromDate,
    isIncludeBookedValues,
    basisPointAdjustment,
    returnComponent,
    hurdleRateCalculationMethodId,
  }: any) => {
    const timeWindow: any = {
      fromDate: fromDate.toISOString(),
      basisPointAdjustment: basisPointAdjustment,
      hurdleRateCalculationMethodId: hurdleRateCalculationMethodId,
    };

    if (returnComponent.includes('-')) {
      timeWindow.returnComponentBenchmarkId = returnComponent;
    } else {
      timeWindow.returnComponentResourceId = Number(returnComponent);
    }

    return {
      name: name,
      typeId: BenchmarkTypes.AbsoluteReturn,
      calculationFrequencyId: calculationFrequency,
      baseCurrencyCode: baseCurrency,
      includeBookedValues: isIncludeBookedValues || false,
      timeWindows: [timeWindow],
    };
  };

  modules[paths.benchmarkCompositeWeighted] = getCompositeWeighted;
  modules[paths.pullForward] = getPullForward;
  modules[paths.benchmarkAbsoluteReturn] = getAbsoluteReturn;

  return modules[pathNameModule](values);
};

export const useCreateBenchmarks = () => {
  const history = useHistory();
  const { pathname } = useLocation();

  const {
    mutate,
    isLoading: isCreatingBenchmarks,
    data: compositeWeightedData,
  }: any = Api.benchmarks.SaveBenchmarks();

  const onSubmit = (values: any) => {
    const body = getBody(pathname, values);
    return mutate({ body });
  };

  if (!isCreatingBenchmarks && compositeWeightedData?.statusText === 'OK') {
    const { id } = compositeWeightedData.data;
    history.push(`${pathname}/${id}`);
  }

  return {
    isCreatingBenchmarks,
    onSubmit,
  };
};
